import isClientSide from "@/js/helpers/isClientSide";

export const extractChatUserId = () => {
  if (isClientSide() && window?.KoreChatSDK) {
    try {
      const userId =
        window.KoreChatSDK?.chatConfig?.jwtGrantSuccessInformation?.userInfo
          ?.userId;
      if (userId) {
        return userId;
      }
    } catch (error) {
      console.warn("Failed to extract chat user ID:", error);
    }
  }
  return null;
};
